import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const WHATSAPP_NUMBER = "5592982002348";
export const WHATSAPP_DISPLAY = "92 9 8200-2348";
export const ADDRESS = "Av. Efigênio Salles, 1299, Sl E — Aleixo, Manaus/AM";

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const waService = (name) =>
  waLink(
    `Olá! Vim pelo site da Contabiltec e quero contratar o serviço: ${name}.`
  );

export const DEFAULT_WA = waLink(
  "Olá! Vim pelo site da Contabiltec e quero saber mais sobre os serviços."
);

export const fmtBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
    v
  );

export const parseBRL = (s) => {
  if (!s) return null;
  const clean = String(s).replace(/[^\d,.-]/g, "");
  if (!clean) return null;
  const normalized = clean.includes(",")
    ? clean.replace(/\./g, "").replace(",", ".")
    : clean;
  const v = parseFloat(normalized);
  return isNaN(v) ? null : v;
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
